import { render } from "./StepWrapper.vue?vue&type=template&id=2c5ddd00"
import script from "./StepWrapper.vue?vue&type=script&lang=js"
export * from "./StepWrapper.vue?vue&type=script&lang=js"

import "./StepWrapper.vue?vue&type=style&index=0&id=2c5ddd00&lang=scss"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__